import axios from 'axios';
import API from '../config/api.config';

export default class Folders {
  constructor() {
    this.API = API;
  }

  apiEndpoint() {
    return this.API.URL('folders/search?q=');
  }

  getFolders() {
    return axios.get(this.apiEndpoint());
  }
}
